export const ACCESS_TOKEN_KEY = "accessToken" as const;
